
// $( document ).ready(function() {
    $(".navbar-toggler").click(function(){
        $(".navbar-collapse").slideToggle();
      });

$(".dropdown-toggle").click(function(){
    $(this).parent().toggleClass("activenav");
});

     
$('.acc-container .acc:nth-child(1) .acc-head').addClass('active');
$('.acc-container .acc:nth-child(1) .acc-content').slideDown();
$('.acc-head').on('click', function() {
    if($(this).hasClass('active')) {
    $(this).siblings('.acc-content').slideUp();
    $(this).removeClass('active');
    }
    else {
    $('.acc-content').slideUp();
    $('.acc-head').removeClass('active');
    $(this).siblings('.acc-content').slideToggle();
    $(this).toggleClass('active');
    }
});  

$('.upslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow:1,
    speed: 5000,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToScroll:1,
    autoplay: true,
    // centerMode:true,
    responsive: [
        {
            breakpoint:993,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              dots: false,
              
            }
          },
          {
            breakpoint:768,
            settings: {
              slidesToShow:1.3,
              slidesToScroll:1,
              infinite: true,
              dots: false,
              
            }
          }        
      
      
      ]
});


$('.videotestislider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow:4,
    slidesToScroll:1,
    autoplay: false,
        prevArrow: $(".slideleftbtn"),
    nextArrow: $(".sliderightbtn"),
    //centerMode:true,

    responsive: [
        {
            breakpoint:1201,
            settings: {
              slidesToShow:3,
              slidesToScroll:1,
              infinite: true,
              arrows: true,
             centerMode:true,
            }
          },  
           {
            breakpoint:1200,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              arrows: true,
             centerMode:true,
            }
          }, 
          {
            breakpoint:768,
            settings: {
              slidesToShow:1,
              slidesToScroll:1,
              infinite: true,
              arrows: true,
             centerMode:true,
            }
          }     
      
      
      ]
    
    
  });
$('.bestsellerslider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow:4,
    slidesToScroll:1,
    autoplay: true,
    adaptiveHeight: true,
    //centerMode:true,

    responsive: [
        {
            breakpoint:1201,
            settings: {
              slidesToShow:3,
              slidesToScroll:1,
              infinite: true,
              arrows: true,
             
            }
          },  
           {
            breakpoint:1200,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              arrows: true,
              prevArrow: $(".slideleftbtn2"),
                nextArrow: $(".sliderightbtn2"),
             
            }
          }, 
          {
            breakpoint:768,
            settings: {
              slidesToShow:1,
              slidesToScroll:1,
              infinite: true,
              arrows: true,
                prevArrow: $(".slideleftbtn2"),
                nextArrow: $(".sliderightbtn2"),
             
            }
          }     
      
      
      ]
    
    
  });

  
    // vars
  var slider, btn, tabC, prevIndex, objTab = {};
  
  btn = $(".btn");
  tabC = $(".tabContent");
  
  prevIndex = 0;
  
  btn.on("click", function() {
    
    var th, thIndex;
    
    th = $(this);
    thIndex = th.index();
       
    if(!th.hasClass("active")) {
      if(prevIndex != thIndex && prevIndex !== 'undefined') {
        btn.eq(prevIndex).removeClass("active");
        tabC.eq(prevIndex).removeClass("show");
      }
      btn.eq(thIndex).addClass("active");
      tabC.eq(thIndex).addClass("show");
      prevIndex = thIndex;
      
      //slick position filter
      //if you have problem with slick in tabs, use next option
      //magic option
      tabC.eq(thIndex).find(".bestsellerslider").slick('setPosition');
    }
  });
  
  slider = $(".bestsellerslider");


$('.peopletestislider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow:2,
    slidesToScroll:1,
    autoplay: true,
    //centerMode:true,

    responsive: [
        {
            breakpoint:1200,
            settings: {
              slidesToShow:1,
              slidesToScroll:1,
              infinite: true,
              arrows: true,
              prevArrow: $(".slideleftbtn3"),
    nextArrow: $(".sliderightbtn3"),
             
            }
          },  
           {
            breakpoint:992,
            settings: {
              slidesToShow:1,
              slidesToScroll:1,
              infinite: true,
              arrows: true,
             prevArrow: $(".slideleftbtn3"),
    nextArrow: $(".sliderightbtn3"),
            }
          }, 
          {
            breakpoint:768,
            settings: {
              slidesToShow:1,
              slidesToScroll:1,
              infinite: true,
              arrows: true,
              prevArrow: $(".slideleftbtn3"),
    nextArrow: $(".sliderightbtn3"),
             
            }
          }     
      ]
  });

  $('.mainimage').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    asNavFor: '.thumbimage'
  });
  $('.thumbimage').slick({
    slidesToShow:5,
    slidesToScroll: 1,
     arrows: false,
    asNavFor: '.mainimage',
    dots: false,
    //centerMode: true,
    focusOnSelect: true,
    responsive: [
        {
            breakpoint:1200,
            settings: {
              slidesToShow:5,
              slidesToScroll:1,
              infinite: true,
              dots: false,
              
            }
          }        
      ]
 
}); 

$('.cehomecollectslider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      arrows: true,
      slidesToShow:1,
      slidesToScroll:1,
      autoplay: false,
        adaptiveHeight: true,
  });

  $('.prdqnt .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.prdqnt').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
   
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.prdqnt').find('.quantity-input').attr("value",qty);
});

    $(".testivideo").click(function () {
    if ($(this).find("video").get(0).paused) {
      $(this).find("video").trigger("play");
      $(this).find(".playbtn").fadeOut(500);
    } else {
      $(this).find("video").trigger("pause");
      $(this).find(".playbtn").fadeIn(500);
    }
  });

  $(".colorvariant h2 span").text($(".colorvariant .active input").val());

  $(".colorvariant input").click(function () {
      var color = $(this).val(); 
      $(".colorvariant h2 span").text(color);
    $(this).parent().parent().find("li").removeClass("active");
    $(this).parent().addClass("active");
    var size = $(".impedencevariant .active input").val();

    if( typeof size == 'undefined'){
      var data = color; 
    } else {
      var data = size + " / " + color; 
    }
    console.log(data);
       
    $(".no-js > option").each(function() {
      if ($(this).text() == data){
        var v_img = $(this).attr("data-val"); 
        var id = $(this).val();
        var pr = $(this).attr("data-pr");
        var cpr = $(this).attr("data-com");
        var inv = $(this).attr("data-inv"); 
        $(".nwprice").text(pr);
        $(".oldprice").text(cpr);
        
        if(inv > 0){
          $(".addcartbtn").prop("disabled",false); 
          $(".addcartbtn span").text("ADD TO CART");
        } else {
          $(".addcartbtn").prop("disabled",true);
          $(".addcartbtn span").text("Out of Stock");
        }
    $(".formval").attr("value",id);
        $( ".thumb" ).each(function() {
      var a = $( this ).attr( "datav" );
      if(a == v_img){
        
        var b = $( this ).parent().parent().attr("data-slick-index");
        $('.thumbimage').slick('slickGoTo', b);
        
      }
    });
        
      }
    });
  });

  $(".impedencevariant input").click(function () {
      var size = $(this).val(); 
    $(this).parent().parent().find("li").removeClass("active");
    $(this).parent().addClass("active");
    var color = $(".colorvariant .active input").val();

    if( typeof color == 'undefined'){
      var data = size; 
    } else {
      var data = size + " / " + color; 
    }
    console.log(data);
       
    $(".no-js > option").each(function() {
      if ($(this).text() == data){
        var v_img = $(this).attr("data-val"); 
        var id = $(this).val();
        var pr = $(this).attr("data-pr");
        var cpr = $(this).attr("data-com");
        var inv = $(this).attr("data-inv"); 
        $(".nwprice").text(pr);
        $(".oldprice").text(cpr);
        
        if(inv > 0){
          $(".addcartbtn").prop("disabled",false); 
          $(".addcartbtn span").text("ADD TO CART");
        } else {
          $(".addcartbtn").prop("disabled",true);
          $(".addcartbtn span").text("Out of Stock");
        }
    $(".formval").attr("value",id);
        $( ".thumb" ).each(function() {
      var a = $( this ).attr( "datav" );
      if(a == v_img){
        
        var b = $( this ).parent().parent().attr("data-slick-index");
        $('.thumbimage').slick('slickGoTo', b);
        
      }
    });
        
      }
    });
  });




// });	


function alertFuncc() {
    $('.cehomecollectslider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      arrows: true,
      slidesToShow:1,
      slidesToScroll:1,
      autoplay: false,
      adaptiveHeight: true,
  });
}
   


function myFunction() {
  timeoutt = setTimeout(alertFuncc, 2000);
}

function addprod(e) {
    var itemsArray = []; 


var customItem = { id: e, quantity: 1 };
    	itemsArray.push(customItem);
    
    	$.ajax({
        	type: 'POST',
        	url: '/cart/add.js',
        	dataType: 'json',
        	data: { items: itemsArray },
        	success: function (data) {
              $.ajax({
                
                    'url' : window.location.href,
                    'dataType' : 'html',
                    'method' : 'GET',
                    'success' : function(data) {
                      $(".drawer").removeClass("is-empty");
                      let form_markupp = $(data).find('#cart-icon-bubble').html();
                        $("#cart-icon-bubble").html(form_markupp);
                        let form_markup = $(data).find('.drawer__inner').html();
                        $(".drawer__inner").html(form_markup);
                      setTimeout(alertFuncc, 2000)
                    }
                });
            		
        	},
        	error: function (data) {
            	alert(data.responseJSON.description);
        	}
    	});
  }